import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";

import Redirect from "components/Redirect";
import Role from "constants/role";
import { isInIframe } from "helpers/app";
import { useBreakpoints } from "hooks/use-breakpoints";
import { useIframeNavigationSync } from "hooks/use-iframe-navigation-sync";
import { useIframeSendAppDataLoadedMessage } from "hooks/use-iframe-send-app-data-loaded-message";
import PageRoute from "routes/PageRoute";
import { selectLoggedInAgentPermission } from "store/entities/agents";

import { AutomationsRoutes } from "../constants";

import AddWorkflow from "./pages/Add";
import EditWorkflow from "./pages/Edit";
import MainPage from "./pages/Main";
import NoMobile from "./pages/NoMobile";

const DOCUMENT_TITLE = "Rules";

export const AutomationsWorkflowsRouter: React.FC = () => {
  const { isMobile } = useBreakpoints();

  const permission = useSelector(selectLoggedInAgentPermission);

  const embeddedInIframe = isInIframe();
  const shouldHidePageOnMobile = isMobile && !embeddedInIframe;
  const isOwner = permission === Role.Owner;

  useIframeNavigationSync();
  useIframeSendAppDataLoadedMessage();

  return (
    <Switch>
      {isOwner && !shouldHidePageOnMobile && (
        <PageRoute path={AutomationsRoutes.AddRule} component={AddWorkflow} documentTitle={DOCUMENT_TITLE} />
      )}
      {isOwner && !shouldHidePageOnMobile && (
        <PageRoute path={`${AutomationsRoutes.EditRule}/:id`} component={EditWorkflow} documentTitle={DOCUMENT_TITLE} />
      )}
      {!shouldHidePageOnMobile && (
        <PageRoute path={AutomationsRoutes.Rules} component={MainPage} documentTitle={DOCUMENT_TITLE} />
      )}
      {shouldHidePageOnMobile && <Route exact path={AutomationsRoutes.Rules} component={NoMobile} />}
      <Redirect to={AutomationsRoutes.Rules} />
    </Switch>
  );
};
